export enum AreaUnit {
    UNKNOWN = 0,
    METER = 1,
    ARE = 2,
    HECTARE = 3,
    MORTGAGE_PAYMENT = 4,
}
